import { gql } from '__generated__'
import { GetCompanyQuery } from '__generated__/graphql'

export type CompanyNote = NonNullable<
    GetCompanyQuery['company']['notes']
>[number]

export const PinCompanyNote = gql(/* GraphQL */ `
    mutation PinCompanyNote($noteId: String!) {
        toggleCompanyNotePin(noteId: $noteId) {
            success
        }
    }
`)

export const AddCompanyNote = gql(/* GraphQL */ `
    mutation AddCompanyNote($companyId: ID!, $title: String!, $note: String) {
        addCompanyNote(companyId: $companyId, title: $title, note: $note) {
            noteData
        }
    }
`)

export const UpdateCompanyNote = gql(/* GraphQL */ `
    mutation UpdateCompanyNote($noteId: ID!, $title: String!, $note: String) {
        updateCompanyNote(noteId: $noteId, title: $title, note: $note) {
            noteData
        }
    }
`)

export const DeleteCompanyNote = gql(/* GraphQL */ `
    mutation DeleteCompanyNote($noteId: String!) {
        deleteCompanyNote(noteId: $noteId) {
            success
        }
    }
`)
